import React, { useEffect } from 'react';

const HeadMeta = ({ children }) => {
  const { NODE_ENV } = process.env
  useEffect(() => {
    document.title = `Salesflow ${NODE_ENV !== 'production' ? `- ${NODE_ENV.toUpperCase()}` : ''}`
  }, [NODE_ENV])

  return (
    <>{children}</>
  );
};


export default HeadMeta;
